export default __webpack_public_path__ + "static/media/1.bafe427f.png";